"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _SafeGrid = _interopRequireDefault(require("01_core/components/materials/SafeGrid"));
var _CActions = _interopRequireDefault(require("../materials/CActions"));
var _TitleHelpMark = _interopRequireDefault(require("../materials/TitleHelpMark"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HEADER_HEIGHT = 36;
const StyledCardHeader = (0, _styles.styled)(_material.CardHeader)(_ref => {
  let {
    theme
  } = _ref;
  return {
    background: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '& .MuiCardHeader-content': {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      height: HEADER_HEIGHT
    }
  };
});
const TitleArea = (0, _styles.styled)('div')({
  display: 'flex',
  fontWeight: 'normal',
  alignItems: 'center',
  verticalAlign: 'middle'
});

/**
 * タイトル付きカード
 * @prop {string} [title] - カードのヘッダ部分に表示するタイトル
 * @prop {node} [help] - 表示するヘルプの内容
 * @prop {node} [children] - 子要素
 * @prop {array} [actions] - アクション要素の配列
 * @prop {bool} [fixedWidth] - 横幅を固定するときに指定する
 */
class TitleCard extends _react.default.Component {
  render() {
    const {
      children,
      actions,
      title,
      help,
      className,
      fixedWidth
    } = this.props;
    const actionComponents = actions ? /*#__PURE__*/_react.default.createElement(_CActions.default, {
      actions: actions
    }) : null;
    return /*#__PURE__*/_react.default.createElement(_material.Card, {
      className: className,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(StyledCardHeader, {
      title: /*#__PURE__*/_react.default.createElement(TitleArea, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        component: "div",
        align: "left",
        variant: "subtitle1",
        color: "text.secondary"
      }, title), help && /*#__PURE__*/_react.default.createElement(_TitleHelpMark.default, {
        help: help
      }))
    }), fixedWidth ? /*#__PURE__*/_react.default.createElement(_SafeGrid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12,
        md: 10,
        lg: 8
      }
    }, children && children, actionComponents)) : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        minWidth: 0
      }
    }, children && children, actionComponents));
  }
}
TitleCard.propTypes = {
  title: _propTypes.default.string,
  help: _propTypes.default.node,
  children: _propTypes.default.node,
  actions: _propTypes.default.array,
  fixedWidth: _propTypes.default.bool
};
var _default = exports.default = TitleCard;